export const employeePayrollTypes = {
  SET_EMPLOYEE_PAYROLL: 'SET_EMPLOYEE_PAYROLL',
  CHANGE_EMPLOYEE_PAYROLL_CELL: 'CHANGE_EMPLOYEE_PAYROLL_CELL',
  SAVE_EMPLOYEE_PAYROLL: 'SAVE_EMPLOYEE_PAYROLL',
  RESET_EMPLOYEE_PAYROLL: 'RESET_EMPLOYEE_PAYROLL',
  FIND_EMPLOYEE_PAYROLL: 'FIND_EMPLOYEE_PAYROLL',
  APPLY_TO_ALL_EMPLOYEE_PAYROLL: 'APPLY_TO_ALL_EMPLOYEE_PAYROLL',
  SET_WEEK_ACTIVE_EMPLOYEE_PAYROLL: 'SET_WEEK_ACTIVE_EMPLOYEE_PAYROLL'
};
